// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toolboxPane--1I2kvY67 {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n  color: var(--text-color-default);\n}\n\n.toolboxPaneHeading--2Q0khNc- {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  height: 42px;\n  padding: 0 12px;\n  color: #fff;\n}\n\n.toolboxPaneTitle--2_Su403P {\n}\n\n.toolboxPaneTooltips--ceTP9LAZ {\n  color: var(--text-color-secondary);\n}\n\n.toolboxPaneBody--LLthEsUV {\n  flex: auto;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.toolboxPaneTooltips--ceTP9LAZ .ant-popover-inner-content > p:last-child {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolboxPane": "toolboxPane--1I2kvY67",
	"toolboxPaneHeading": "toolboxPaneHeading--2Q0khNc-",
	"toolboxPaneTitle": "toolboxPaneTitle--2_Su403P",
	"toolboxPaneTooltips": "toolboxPaneTooltips--ceTP9LAZ",
	"toolboxPaneBody": "toolboxPaneBody--LLthEsUV"
};
export default ___CSS_LOADER_EXPORT___;
